<template>
  <div class="chartsBox" :ref="queryParames.kpiKey">
    <div class="model" v-if="!showCharts">
      <i class="uk-icon-loading"></i>
      <div>{{$t('common.loading')}}</div>
    </div>
    <chart-config :ref="chartData.chartId"
    v-if="showCharts"
    :icon="icon"
    :chart-index="index" 
    :chart-id="chartData.chartId" 
    :title="queryParames.desc"
    :chart-data="chartData.chartData" 
    :chart-style="styleData"
    :click-fun="onItemClick"
    :clickable="true"
    :show-color-icon="true">
    </chart-config>
  </div>
</template>
<script>
import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
import AlarmStrategyBiz from '@/logic/systemSetting/alarmStrategyBiz'
import tab from '@/views/layout/components/setTab'
import chartConfig from './chart-config'
import { extend } from '@/utils/tool'
const CHART_STYLE = {
  grid: {
    left: '4%',
    bottom: '5%',
    top: '14%',
    right: '6%',
    containLabel: true
  },
  toolbox: {
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      restore: {}
    },
    right: '2%'
  },
  legend: {
    data: [],
    top: 4
  }
}
export default {
  data(){
    const that = this
    return{
      // chartData: {},
      icon: {
        label: that.$t('common.edit'),
        classname: 'icon-xiugai'
      },
      styleData: {},
      showCharts: false
    }
  },
  components: {
    chartConfig
  },
  props: {
    queryParames: {
      type: Object,
      default(){
        return {}
      }
    },
    index: {
      type: Number
    },
  },
  watch: {
    queryParames: {
      deep: true,
      immediate:true,
      handler: function (val) {
        this.$nextTick(() => {
          this.setIntersectionOb(this.$refs[val.kpiKey])
        })
      }
    }
  },
  methods: {
    setIntersectionOb(el) {
      const io = new IntersectionObserver((entries) => {
        if(entries[0].intersectionRatio > 0) {
          this.getKpiData(this.queryParames)
          io.disconnect()
        }
      }, {});
      io.observe(el);
    },
    getKpiData(params) {
      ITDeviceMonitorBiz.getChartDataNoModel({...params}).then(data => {
        this.chartData = {
          title: this.queryParames.desc,
          kpiInfo: {
            appGroup: this.queryParames.group,
            appName: this.queryParames.appName,
            kpiKey: this.queryParames.kpiKey,
            siteCode: this.$route.query.siteCode
          },
          chartId: `chartGroups-serverAPP-${this.queryParames.desc}${this.index}`,
          chartData: {
            rows: data ? data : [],
            columns: ['eventTime', 'value'],
            alarm: this.queryParames.alarm,
            formatMap: {
              eventTime: 'TIME'
            },
            labelMap: {
              value: this.queryParames.desc
            }
          }
        }
        const style = extend(true, {}, CHART_STYLE)
        this.styleData = this.handleLegend(style, this.chartData.chartData)
        this.showCharts = true
      }).catch(err => {
      })
    },
    handleLegend (style, chartData) {
      if (chartData.labelMap && Object.keys(chartData.labelMap).length > 1) {
        Object.keys(chartData.labelMap).map(item => {
          style.legend.data.push(chartData.labelMap[item])
        })
      }
      return style
    },
    onItemClick (index) {
      this.$emit('chart-conf-click', {
        index: this.index,
        data: this.chartData
      })
      let kpiInfo = this.chartData.kpiInfo
      if (kpiInfo) {
        AlarmStrategyBiz.findAlarmStrategyId({
          group: kpiInfo.appGroup,
          appName: kpiInfo.appName,
          kpiKey: kpiInfo.kpiKey,
          siteCode: kpiInfo.siteCode
        }).then((data) => {
          let strategyInfo = data
          if (strategyInfo.length > 0 && strategyInfo[0].alarmCode) {
            this.$router.push({ path: `/home/alarmStrategy/editStrategy?alarmCode=${strategyInfo[0].alarmCode}` })
            tab.selectTab('alarmStrategy')
          } else {
            this.$router.push({ path: `/home/alarmStrategy/addStrategy?appName=${kpiInfo.appName}&appGroup=${kpiInfo.appGroup}&kpiKey=${kpiInfo.kpiKey}&sourceType=1` })
            tab.selectTab('alarmStrategy')
          }
        })
      }
    },
  }
}
</script>
<style scoped>
.chartsBox{
  display: inline-block;
  margin: 0 16px 16px 0;
  width: 400px;
  height: 260px;
  vertical-align: middle;
}
.chartsBox .model{
  width: 400px; height: 260px; background-color: rgba(0, 0, 0, 0.1); transition: opacity 0.3s; 
  display: flex; align-items: center; justify-content: center; flex-direction: column; color: #0B8DE5;
}
.chartsBox .model i{
  font-size: 26px; margin-bottom: 10px;
}
</style>